import Modal from '@/src/components/Modal/Modal';

import ReactTooltip from 'react-tooltip';
import ModalHeader from '@/src/components/Modal/ModalHeader';
import CallMeBackForm from '@/src/components/UI/Forms/CallMeBackForm';
import { FC } from 'react';
import Image from 'next/image';
import { Agent } from '@/swagger';

const QRCode = require('qrcode.react');

interface ModalPopupProps {
  showCallMeBackForm: boolean;
  setShowCallMeBackForm: (value: boolean) => void;
  showLinePopup: boolean;
  setShowLinePopup: (value: boolean) => void;
  agent: Agent;
  needAddress?: boolean;
  listingId?: string;
}

const ModalPopup: FC<ModalPopupProps> = ({
  showCallMeBackForm,
  setShowCallMeBackForm,
  showLinePopup,
  setShowLinePopup,
  needAddress,
  listingId,
}) => {
  return (
    <div>
      <Modal show={showCallMeBackForm}>
        <CallMeBackForm
          closeBtnPress={() => setShowCallMeBackForm(false)}
          needAddress={needAddress}
          listingId={listingId}
        />
      </Modal>
      <ReactTooltip backgroundColor='black' place={'bottom'} />
      <LinePopup
        showLinePopup={showLinePopup}
        setShowLinePopup={setShowLinePopup}
        lineQR={'https://line.me/ti/p/@funwoo'}
      />
    </div>
  );
};
export const LinePopup = ({
  showLinePopup,
  lineQR,
  setShowLinePopup,
}: {
  lineQR: string;
  showLinePopup: boolean;
  setShowLinePopup: (value: boolean) => void;
}) => {
  return (
    <Modal show={showLinePopup} zIndex={100}>
      <div className={' w-100 h-5/6 bg-white'}>
        <ModalHeader closeBtnPress={() => setShowLinePopup(false)} title={`掃描 QR 碼聯絡 客服專員`} />
        <div className={'flex justify-center w-full h-full items-center'}>
          <div className={'w-64 h-64 relative items-center justify-center'}>
            <QRCode style={{ position: 'relative' }} size={256} value={lineQR} />
            <div className={'absolute w-full h-full  items-center top-0 justify-center z-50  flex'}>
              <Image src={'/line-logo.png'} width={30} height={30} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default ModalPopup;
